import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EngagementType } from '@interfaces';
import { CommonScheduledFollowUpsGridPart } from '../../../../../ui/widget';
import { ExperienceEngagementsService } from '../../experience-engagements.service';

@Component({
	selector: 'experience-follow-ups-view-part',
	standalone: true,
	imports: [CommonScheduledFollowUpsGridPart],
	templateUrl: './scheduled-follow-ups.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./scheduled-follow-ups.part.scss'],
})
export class ExperienceFollowUpsFollowUpsViewPart implements OnInit {

	public readonly pageService = inject(ExperienceEngagementsService);
	public followUps = computed(() => (this.pageService.followUps() || []));

	ngOnInit() {
		this.pageService.engagementType.set(EngagementType.scheduledFollowUps);
	}
}